import React from 'react'
import {useSearchParams} from 'react-router-dom'
import PageLayout from '../../../components/layout/PageLayout'
import CommentDetailContainer from '../../../features/page/post/comment/CommentDetailContainer'

interface IProps {
    className?: string
}

const CommentDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const commentId = searchParams.get('id')

    return (
        <PageLayout title={'Comment Detail'} className={`${className}`}>
            <CommentDetailContainer commentId={commentId} />
        </PageLayout>
    )
}

export default CommentDetailPage
